import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Banner, List } from '@shopify/polaris';

const propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.shape({
    content: PropTypes.string,
    url: PropTypes.string,
  }),

  status: PropTypes.oneOf(["success", "warning", "info", "critical"]),
  message: PropTypes.string,
};

const defaultProps = {

}


const CallToActionBanner = (props) => (
  <Banner
    title={ props.title }
    action={props.action}
    status={ props.status }
    >
    <List>
      <List.Item>
       { props.message }
      </List.Item>
    </List>
  </Banner>
)

CallToActionBanner.propTypes = propTypes;
CallToActionBanner.defaultProps = defaultProps;

export default CallToActionBanner;